import { useCallback } from 'react';
import { useSettings } from './useSettings';

/**
 * Панель атрибутов текстовой коммуникации: по умолчанию скрыта, чтобы переписке хватало места.
 * Выбор запоминается за пользователем один на все текстовые коммуникации и все раскладки — следующая
 * открывается с панелью в том же состоянии.
 */
export const useTextAttributesPanel = () => {
  const { dialogsPage, setDialogsSettings } = useSettings();

  const isAttributesPanelOpen = dialogsPage.textAttributesPanelOpen ?? false;

  const setAttributesPanelOpen = useCallback(
    (isOpen: boolean) => setDialogsSettings({ textAttributesPanelOpen: isOpen }),
    [setDialogsSettings],
  );

  const toggleAttributesPanel = useCallback(
    () => setAttributesPanelOpen(!isAttributesPanelOpen),
    [isAttributesPanelOpen, setAttributesPanelOpen],
  );

  return { isAttributesPanelOpen, setAttributesPanelOpen, toggleAttributesPanel };
};
